export const CLOSE_IFI_MODAL = 'TEMPLATES:IFI:CLOSE_MODAL';